import React from 'react';
import { Link } from 'react-router-dom';
import { Palette, Users, ClipboardCheck, Truck, ArrowRight } from 'lucide-react';
export const HowItWorks = () => {
  const steps = [{
    icon: Palette,
    title: '1. Design Online',
    desc: 'Create an account and use our 3D designer to build your custom uniform. Select colors, upload logos, and add names and numbers.'
  }, {
    icon: Users,
    title: '2. Connect with a Dealer',
    desc: 'If you are an end-user or team, we can connect you with a registered dealer to help finalize and place your order.'
  }, {
    icon: ClipboardCheck,
    title: '3. Review & Approve',
    desc: 'Our team reviews artwork, sizing, and production details. We provide mockups and samples for final approval before production begins.'
  }, {
    icon: Truck,
    title: '4. Production & Delivery',
    desc: 'Orders undergo rigorous quality control during manufacturing and are drop-shipped directly to you or your customer.'
  }];
  return <div className="py-20 lg:py-24 bg-gray50 min-h-[calc(100vh-300px)]" data-id="element-800">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-801">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-802">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-803">
            The Process
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-804">
            How It Works
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-805">
            From initial design to final delivery, our streamlined process
            ensures accuracy, quality, and speed for every custom uniform order.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-806">
          {steps.map((step, i) => <div key={i} className="bg-white p-8 rounded-xl border border-gray200 shadow-sm relative" data-id="element-807">
              <div className="w-16 h-16 rounded-full bg-brandRed/10 flex items-center justify-center mb-6" data-id="element-808">
                <step.icon className="w-8 h-8 text-brandRed" strokeWidth={1.5} data-id="element-809" />
              </div>
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-810">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-811">{step.desc}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-812">
          <Link to="/products" className="inline-flex items-center justify-center gap-2 bg-brandRed hover:bg-brandRedDark text-white font-bold py-4 px-8 rounded-sm transition-colors text-base shadow-lg group" data-id="element-813">
            Start Designing Now
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-814" />
          </Link>
        </div>
      </div>
    </div>;
};